import React, { useEffect, useState } from 'react';
import Dropdown from "react-dropdown";
import searchIcon from './Assets/Search.png';
import { useApp } from '../../../../../AppProvider';
import DeleteIcon from '../../../../Setting/SettingsAssets/Delete.svg';
import logger from "../../../../../utils/logger";
import './AddMedicine.css';


const AddMedicine = ({ setIsMedicineModalOpen }) => {
  const { searchMedicineData, searchQuery, setSearchQuery, setSearchMedicineData, medicationGroup, mediTableContent,
    setMediTableContent, setDoctorAdvice, setDiagnosisCards, selectedPatientObj, fetchSearchMedicineAPI, doctorAdvice,
    prescriptionOptions } = useApp();
  const [addMedicineOption, setAddMedicineOption] = useState();
  const [showCustomForm, setShowCustomForm] = useState(false);
  const [customBrand, setCustomBrand] = useState('');
  const [customDrug, setCustomDrug] = useState('');


  const handleDeleteClick = (serialNo) => {
    const updatedMediTableContent = mediTableContent.filter(
      (item) => item.serialNo !== serialNo
    );
    setMediTableContent(
      updatedMediTableContent.map((item, index) => ({
        ...item,
        serialNo: (index + 1).toString()
      }))
    );
  };

  useEffect(() => {
    if (searchQuery.length >= 3) {
      fetchSearchMedicineAPI(searchQuery);
    } else {
      setSearchMedicineData([]); // Clear results if query length is less than 3
    }
  }, [searchQuery]);

  const handleSearchChangeBrand = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
  };


  const handleResultClick = (item) => {
    setSearchMedicineData([]);
    setSearchQuery(item.sku);
    const newMedicine = {
      serialNo: (mediTableContent.length + 1).toString(),
      skuId: item._id,
      brand: item.sku,
      drugsName: item.subGroup,
      quantity: '1 tablet',
      duration: '',
      dosage: '',
      whenToTake: '',
      remarks: ''
    };
    setMediTableContent([...mediTableContent, newMedicine]);
    setSearchQuery('');
  };

  const handleAddCustomClick = () => {
    setSearchMedicineData([]);
    setCustomBrand(searchQuery);
    setCustomDrug('');
    setSearchQuery('');
    setShowCustomForm(true);
  };

  const handleCustomMedicineAdd = () => {
    if (!customBrand.trim()) return;
    const newMedicine = {
      serialNo: (mediTableContent.length + 1).toString(),
      skuId: null,
      brand: customBrand.trim(),
      drugsName: customDrug.trim(),
      quantity: '1 tablet',
      duration: '',
      dosage: '',
      whenToTake: '',
      remarks: ''
    };
    setMediTableContent([...mediTableContent, newMedicine]);
    setShowCustomForm(false);
    setCustomBrand('');
    setCustomDrug('');
  };

  const handleInputChange = (serialNo, columnKey, value) => {
    const updatedContent = mediTableContent.map((item) => {
      if (item.serialNo === serialNo) {
        return { ...item, [columnKey]: value };
      }
      return item;
    });
    setMediTableContent(updatedContent);
  };

  const medicationGroupOptions = medicationGroup.map(group => ({
    label: group.groupName,
    value: group._id
  }));

  logger.debug("medicationGroup", medicationGroup)

  const doctorAdviceSection = (group) => {

    setDoctorAdvice((prev) => [
      ...(prev || []),
      group.advice, // add string as single entry
    ]);
    logger.debug(doctorAdvice)
  };


  const handleDropdownChange = (option) => {
    setAddMedicineOption(option.value);
    const selectedGroup = medicationGroup.find(group => group._id === option.value);
    if (selectedGroup) {
      doctorAdviceSection(selectedGroup);
      if (selectedGroup.tags?.length) {
        const diagnosisItems = Array.isArray(selectedGroup.tags)
          ? selectedGroup.tags
          : selectedGroup.tags.split(',').map(t => t.trim()).filter(Boolean);
        setDiagnosisCards(prev => [...(prev || []), ...diagnosisItems]);
      }
      const newTableContent = selectedGroup.medicines.map((item, index) => ({
        serialNo: (index + 1).toString(),
        brand: item.brand,
        drugsName: item.drugsName,
        quantity: item.quantity,
        duration: item.duration,
        dosage: item.dosage,
        whenToTake: item.take,
        remarks: item.remark,
        skuId: item._id
      }));
      setMediTableContent(newTableContent);
    }
  };


  return (
    <div className="add__medicine-overlay_page">
      <div className="add__medicine-main-container">
        <h2 className="add__medicine-main-container-heading">Add Medicines</h2>
        <div className="add__medicine-input-type-search">
          <div className="add__medicine-search-container">
            <img src={searchIcon} className="add__medicine-search-icon" alt="search" />
            <input
              className="add__medicine-input-type-align"
              type="text"
              placeholder="search brand"
              value={searchQuery}
              onChange={handleSearchChangeBrand}
            />
            {(searchMedicineData.length > 0 || searchQuery.length >= 3) && !showCustomForm && (
              <div className="add__medicine-search-results">
                <div className="add__medicine-brandsearch add__medicine-custom-option" onClick={handleAddCustomClick}>
                  + Add &ldquo;{searchQuery}&rdquo; as custom medicine
                </div>
                {searchMedicineData.map((item, index) => (
                  <div className="add__medicine-brandsearch" key={index} onClick={() => handleResultClick(item)}>
                    <span className="add__medicine-brandsearch-sku">{item.sku}</span>
                    <span className="add__medicine-brandsearch-subgroup">{item.subGroup}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="add__medicine-dropdown-container">
            <Dropdown
              controlClassName="my-dropdown-control_groups"
              options={medicationGroupOptions}
              onChange={handleDropdownChange}
              value={addMedicineOption}
              placeholder="Select Medicine Group"
            />
          </div>
        </div>
        {showCustomForm && (
          <div className="add__medicine-custom-form">
            <input
              className="add__medicine-custom-input"
              type="text"
              placeholder="Brand name"
              value={customBrand}
              onChange={(e) => setCustomBrand(e.target.value)}
            />
            <input
              className="add__medicine-custom-input"
              type="text"
              placeholder="Drug / generic name"
              value={customDrug}
              onChange={(e) => setCustomDrug(e.target.value)}
            />
            <div className="add__medicine-custom-actions">
              <button className="add__medicine-custom-btn-cancel" onClick={() => { setShowCustomForm(false); setCustomBrand(''); setCustomDrug(''); }}>Cancel</button>
              <button className="add__medicine-custom-btn-add" onClick={handleCustomMedicineAdd}>Add</button>
            </div>
          </div>
        )}
        <div className="add__medicine-table-wrapper">
          <table className="add__medicine-medi_table">
            <thead>
              <tr className="add__medicine-tableheader">
                <th className="add__medicine-header_text">S.No.</th>
                <th className="add__medicine-header_text">Brand Name</th>
                <th className="add__medicine-header_text">Drug Name</th>
                <th className="add__medicine-header_text">Quantity</th>
                <th className="add__medicine-header_text">Duration</th>
                <th className="add__medicine-header_text">Dosage</th>
                <th className="add__medicine-header_text">When to Take</th>
                <th className="add__medicine-header_text">Remarks</th>
                <th className="add__medicine-header_text">Delete</th>
              </tr>
            </thead>
            <tbody>
              {mediTableContent.length > 0 ? (
                mediTableContent.map((group) => (
                  <tr className="add__medicine-tableheader-col" key={group.serialNo}>
                    <td className="add__medicine-table_el">{group.serialNo}</td>
                    <td className="add__medicine-table_el-brand">{group.brand}</td>
                    <td className="add__medicine-table_el-durgs">{group.drugsName}</td>
                    {/* Quantity */}
                    <td className="add__medicine-table_el">
                      <select
                        className="add__medicine-table-input"
                        value={group.quantity || ""}
                        onChange={(e) => handleInputChange(group.serialNo, "quantity", e.target.value)} >
                        <option value="">Select quantity</option>
                        {(prescriptionOptions?.quantity || []).map(opt => (
                          <option key={opt} value={opt}>{opt}</option>
                        ))}
                      </select>
                    </td>
                    {/* Duration */}
                    <td className="add__medicine-table_el">
                      <select
                        className="add__medicine-table-input"
                        value={group.duration || ""}
                        onChange={(e) => handleInputChange(group.serialNo, "duration", e.target.value)} >
                        <option value="">Select duration</option>
                        {(prescriptionOptions?.duration || []).map(opt => (
                          <option key={opt} value={opt}>{opt}</option>
                        ))}
                      </select>
                    </td>
                    {/* Dosage */}
                    <td className="add__medicine-table_el">
                      <select
                        className="add__medicine-table-input"
                        value={group.dosage || ""}
                        onChange={(e) => handleInputChange(group.serialNo, "dosage", e.target.value)} >
                        <option value="">Select dosage</option>
                        {(prescriptionOptions?.dosage || []).map(opt => (
                          <option key={opt} value={opt}>{opt}</option>
                        ))}
                      </select>
                    </td>
                    {/* When To Take */}
                    <td className="add__medicine-table_el">
                      <select
                        className="add__medicine-table-input"
                        value={group.whenToTake || ""}
                        onChange={(e) => handleInputChange(group.serialNo, "whenToTake", e.target.value)}>
                        <option value="">Select time</option>
                        {(prescriptionOptions?.whenToTake || []).map(opt => (
                          <option key={opt} value={opt}>{opt}</option>
                        ))}
                      </select>
                    </td>
                    {/* Remarks */}
                    <td className="add__medicine-table_el">
                      <input
                        className="add__medicine-table-input"
                        type="text"
                        placeholder="Enter remarks"
                        value={group.remarks}
                        onChange={(e) => handleInputChange(group.serialNo, "remarks", e.target.value)} />
                    </td>
                    {/* Delete */}
                    <td className="add__medicine-table_el">
                      <img
                        className="medicine-delete_icon_doctor"
                        src={DeleteIcon}
                        alt="deleteicon"
                        onClick={() => handleDeleteClick(group.serialNo)}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="add__medicine-no_medicine_selected">
                  <td colSpan="9" className="add__medicine-no_medicine_selected-cell">
                    No Medicine Selected
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="medicine-bottom-button-div">
          <button className="medicine-bottom-button-right" onClick={() => { setIsMedicineModalOpen(false); setSearchQuery('') }}>Cancel</button>
          <button className="medicine-bottom-button-left" onClick={() => setIsMedicineModalOpen(false)}>Add Medicine</button>
        </div>
      </div>
    </div>
  );
};

export default AddMedicine;
